import React from 'react';
import projects from '../../assets/img/presentation.png';
import training  from '../../assets/img/education.png';
import events    from '../../assets/img/fireworks.png';

const FeatureCard = ({ variant, icon, title, description, onClick }) => (
  <div className="bgg-feature-card" onClick={onClick}>
    <div className={`bgg-feature-header ${variant}`}>
      <div className="bgg-feature-icon-wrap">
        <img src={icon} alt={title} />
      </div>
      <h3>{title}</h3>
    </div>
    <div className="bgg-feature-body">
      <p>{description}</p>
      <button className="bgg-arrow-btn">
        View All &nbsp;&#8594;
      </button>
    </div>
  </div>
);

const FeaturesSection = (props) => (
  <section className="bgg-features-section">
    <div className="bgg-container">
      <div className="bgg-section-header">
        <span className="bgg-section-label">What We Do</span>
        <div>
          <h2 className="bgg-section-title">Our Focus Areas</h2>
        </div>
      </div>
      <div className="bgg-features-grid">
        <FeatureCard
          variant="v1"
          icon={projects}
          title={props.projects || 'Projects'}
          description={props.projectsDesc || ''}
          onClick={() =>
            props.history.push(window.language.currUrl(props.match, 'projects'))
          }
        />
        <FeatureCard
          variant="v2"
          icon={training}
          title={props.trainings || 'Trainings'}
          description={props.trainingsDesc || ''}
          onClick={() =>
            props.history.push(window.language.currUrl(props.match, 'trainings'))
          }
        />
        <FeatureCard
          variant="v3"
          icon={events}
          title={props.events || 'Events'}
          description={props.eventsDesc || ''}
          onClick={() =>
            props.history.push(window.language.currUrl(props.match, 'events'))
          }
        />
      </div>
    </div>
  </section>
);

export default FeaturesSection;



// WEBPACK FOOTER //
// ./src/components/FlippingCard/FlippingCard.jsx